import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MANUAL_SECTIONS, ManualSection } from '../manual-content';

@Component({
  selector: 'app-manual-index',
  templateUrl: './manual-index.component.html',
  styleUrls: ['./manual-index.component.css']
})
export class ManualIndexComponent implements OnInit {
  sections: ManualSection[] = MANUAL_SECTIONS;
  searchText: string = '';
  audienceFilter: string = 'all';
  expandedSections: { [key: string]: boolean } = {};
  activeSection: string = '';
  copiedAnchor: string = '';
  private copiedTimeout: any;

  constructor(private route: ActivatedRoute) {}

  ngOnInit() {
    // Expand first section by default
    if (this.sections.length > 0) {
      this.expandedSections[this.sections[0].id] = true;
      this.activeSection = this.sections[0].id;
    }

    // Handle fragment navigation
    this.route.fragment.subscribe(fragment => {
      if (fragment) {
        this.scrollToSection(fragment);
      }
    });
  }

  toggleSection(sectionId: string) {
    this.expandedSections[sectionId] = !this.expandedSections[sectionId];
  }

  scrollToSection(sectionId: string) {
    this.activeSection = sectionId;
    this.expandedSections[sectionId] = true;

    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  scrollToSubsection(sectionId: string, subsectionId: string) {
    this.activeSection = sectionId;
    this.expandedSections[sectionId] = true;

    setTimeout(() => {
      const element = document.getElementById(subsectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  }

  copySectionLink(anchorId: string) {
    const link = `${window.location.origin}/manual#${anchorId}`;

    this.copyToClipboard(link).then(() => {
      this.copiedAnchor = anchorId;
      if (this.copiedTimeout) {
        clearTimeout(this.copiedTimeout);
      }
      this.copiedTimeout = setTimeout(() => this.copiedAnchor = '', 1800);
    });
  }

  private copyToClipboard(value: string): Promise<void> {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value);
    }

    const textArea = document.createElement('textarea');
    textArea.value = value;
    textArea.setAttribute('readonly', '');
    textArea.style.position = 'fixed';
    textArea.style.left = '-9999px';
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('copy');
    document.body.removeChild(textArea);

    return Promise.resolve();
  }

  expandAll() {
    this.sections.forEach(s => this.expandedSections[s.id] = true);
  }

  collapseAll() {
    this.sections.forEach(s => this.expandedSections[s.id] = false);
  }

  onSearchChange() {
    if (this.searchText.trim().length > 0) {
      this.expandAll();
    }
  }

  getAudienceBadge(audience: string): string {
    switch (audience) {
      case 'user': return 'User';
      case 'admin': return 'Admin';
      default: return '';
    }
  }

  printManual() {
    this.expandAll();
    setTimeout(() => window.print(), 300);
  }
}
